import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography } from '@mui/material';

interface CommentDialogProps {
  open: boolean;
  onClose: () => void;
  comment: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
}

const CommentDialog: React.FC<CommentDialogProps> = ({ open, onClose, comment, onChange, onSubmit }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add or Remove Comment</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Enter comment for selected device(s). Leave empty to remove existing comments.
        </Typography>
        <TextField
          autoFocus
          margin="dense"
          label="Comment"
          fullWidth
          multiline
          rows={4}
          value={comment}
          onChange={(e) => onChange(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onSubmit} variant="contained" color="primary">
          {comment.trim() === '' ? 'Remove Comments' : 'Add Comment'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CommentDialog;






